// Navigation translations - English
export const navigationEn = {
  // Navbar links
  links: {
    home: 'Home',
    vehicles: 'Vehicles',
    buyDirect: 'Sell Your Car',
    consignments: 'Consignment',
    financing: 'Financing',
    weSearchForYou: 'Car Finder',
    contact: 'Contact',
    book: 'Book a Visit',
  },

  // Breadcrumbs
  breadcrumbs: {
    home: 'Home',
    vehicles: 'Vehicles',
    vehicleDetails: 'Vehicle details',
    contact: 'Contact',
    financing: 'Financing',
    consignments: 'Consignment',
    buyDirect: 'Sell Your Car',
    weSearchForYou: 'Car Finder',
  },

  // Buttons
  buttons: {
    menu: 'Menu',
    close: 'Close',
    back: 'Back',
    home: 'Go home',
  },
};



